module.exports = __webpack_public_path__ + "static/faq_shape_1-96f8f4f388dca0126e34c37bd2f2a7f9.svg";